import type { Dispatch, SetStateAction } from 'react'
import { PendingStatusEventTriggers } from '../constants/PendingStatusTriggers'
import type {
    ActionEndedEventDetail,
    ActionFailedEventDetail,
    ActionSuccessEventDetail,
    SubmitSuccessEventDetail,
} from '../../../types/EventDetailTypes'

type EventsThatInfluencePendingStatus = CustomEvent<
    SubmitSuccessEventDetail | ActionFailedEventDetail | ActionSuccessEventDetail | ActionEndedEventDetail
>

/**
 * @memberof usePendingStatus
 * */
export const onEventSetPendingStatus = (
    eventTrigger: PendingStatusEventTriggers,
    formId: string,
    setPending: Dispatch<SetStateAction<boolean>>,
    signal: AbortSignal,
) => {
    document.addEventListener(
        eventTrigger,
        (e) => {
            const event = e as EventsThatInfluencePendingStatus
            if (!(event instanceof CustomEvent)) {
                return
            }
            if (event.detail?.formId !== formId) {
                return
            }
            if (eventTrigger === PendingStatusEventTriggers.SUBMIT_SUCCESS) {
                setPending(true)
                return
            }
            setPending(false)
        },
        { signal },
    )
}
